<template>
	<div class="pa-2">
		<v-combobox
			ref="regular_customer_combobox"
			v-model="client.regularCustomer"
			label="得意先を探す"
			item-text="name"
			item-value="id"
			class="mt-4"
			outlined
			dense
			:hint="regularCustomerHint"
			@keyup="setSearchRegularCustomer"
			@change="changeRegularCustomer"
			:items="regularCustomers"
			no-data-text="選択肢がありません"
		/>
		<v-select
			v-model="client.regularCustomerPerson"
			label="得意先担当者"
			class="mt-4"
			outlined
			required
			dense
			:items="regularCustomerPersons"
			item-text="name"
			item-value="id"
			no-data-text="得意先を選択してください"
		>
		</v-select>

		<v-combobox
			ref="end_user_combobox"
			v-model="client.endUser"
			label="エンドユーザーを探す"
			item-text="name"
			item-value="id"
			class="mt-4"
			outlined
			dense
			:hint="endUserHint"
			@keyup="setSearchEndUser"
			@change="changeEndUser"
			:items="endUsers"
			no-data-text="選択肢がありません"
		/>

		<v-select
			v-model="client.customerPerson"
			label="エンドユーザー担当者"
			class="mt-4"
			outlined
			required
			dense
			:items="customerPersons"
			item-text="name"
			item-value="id"
			no-data-text="エンドユーザーを選択してください"
		>
		</v-select>

		<v-combobox
			ref="plant_company_combobox"
			v-model="client.plantCompany"
			label="プラントメーカーを探す"
			item-text="name"
			item-value="id"
			class="mt-4"
			outlined
			dense
			:hint="plantCompanyHint"
			@keyup="setSearchPlantCompany"
			@change="changePlantCompany"
			:items="plantCompanies"
			no-data-text="選択肢がありません"
		/>

		<div class="distribution-channel-area">
			<h2>商流</h2>
			<p class="font-weight-bold">
				<span>当社: {{ current_company_name }}</span>
			</p>
			<p class="font-weight-bold">
				<span>始点: </span
				><span v-if="client.regularCustomer"> {{ client.regularCustomer.name }}</span>
			</p>
			<p class="font-weight-bold">
				<span>終点: </span><span v-if="client.endUser"> {{ client.endUser.name }}</span>
			</p>
			<v-row no-gutters class="mt-4" justify="start">
				<v-btn color="secondary" @click="addForm" :disabled="disabled"
					><i class="fas fa-plus"></i> 商流を追加する
				</v-btn>
			</v-row>
			<div
				v-for="(text_field, index) in distributionChannels"
				:key="`distributionChannel-${index}`"
			>
				<v-combobox
					:id="`distribution${index + 1}`"
					ref="distribution_combobox"
					v-model="text_field.value"
					label="会社名を検索"
					item-text="name"
					item-value="id"
					class="mt-4"
					hide-details
					outlined
					dense
					@keyup="setSearchDistributionChannel"
					@change="changeDistributionChannel($event, index)"
					:items="distribution_channels"
					no-data-text="選択肢がありません"
				/>
				<v-icon class="icon" :ref="'icon' + index + 1" :id="`icon${index + 1}`"
					>mdi-arrow-down-thin</v-icon
				>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"

export default {
	props: {
		client: {
			type: Object,
			required: false,
			default: () => {},
		},
		customer_companies: {
			type: Array,
			required: false,
			default: () => [],
		},
		current_company_name: {
			type: String,
		},
		distributionChannels: {
			type: Array,
			required: false,
			default: () => [],
		},
		editRegularCustomerPersons: {
			type: Array,
			required: false,
			default: () => [],
		},
		editCustomerPersons: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	data() {
		return {
			customerPersons: [],
			regularCustomers: [],
			regularCustomerPersons: [],
			endUsers: [],
			plantCompanies: [],
			regularCustomerKeyword: null,
			endUserKeyword: null,
			plantCompanyKeyword: null,
			searchRegularCustomersTimer: null,
			searchEndUserTimer: null,
			searchPlantCompanyTimer: null,
			errorRegularCustomerFlag: false,
			errorEndUserFlag: false,
			errorPlantCompanyFlag: false,
			count: 0,
			distribution_channels: [],
			distributionChannelKeyword: null,
			searchdistributionChannelTimer: null,
			errorDistributionChannelFlag: false,
			label: "会社名を検索",
			disabled: false,
		}
	},
	methods: {
		setSearchRegularCustomer(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.regularCustomers = []
			this.regularCustomerKeyword = e.target.value
			clearTimeout(this.searchRegularCustomersTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.regularCustomerKeyword.length) return // 0文字の場合はreturn
			this.searchRegularCustomersTimer = setTimeout(this.searchRegularCustomers, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchRegularCustomers() {
			const params = {
				q: {
					name_cont: this.regularCustomerKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_customer_companies", {
					headers,
					params,
				})
				.then((res) => {
					this.searchRegularCustomersTimer = null
					this.regularCustomers = res.data.customer_companies
					this.errorRegularCustomerFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeRegularCustomer() {
			// テキスト追加時の削除
			if (!this.regularCustomers.includes(this.client.regularCustomer)) {
				this.errorRegularCustomerFlag = true
				this.client.regularCustomer = null
				this.$refs.regular_customer_combobox.reset()
			}
			// 得意先担当者をセット
			this.regularCustomerPersons = []
			if (this.client.regularCustomer) {
				this.regularCustomerPersons = this.client.regularCustomer.customer_persons
			}
		},
		setSearchPlantCompany(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.plantCompanies = []

			this.plantCompanyKeyword = e.target.value
			clearTimeout(this.searchPlantCompanyTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.plantCompanyKeyword.length) return // 0文字の場合はreturn
			this.searchPlantCompanyTimer = setTimeout(this.searchPlantCompany, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchPlantCompany() {
			const params = {
				q: {
					name_cont: this.plantCompanyKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_customer_companies", {
					headers,
					params,
				})
				.then((res) => {
					this.searchPlantCompanyTimer = null
					this.plantCompanies = res.data.customer_companies
					this.errorPlantCompanyFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setSearchEndUser(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.endUsers = []

			this.endUserKeyword = e.target.value
			clearTimeout(this.searchEndUserTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.endUserKeyword.length) return // 0文字の場合はreturn
			this.searchEndUserTimer = setTimeout(this.searchEndUser, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchEndUser() {
			const params = {
				q: {
					name_cont: this.endUserKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_customer_companies", {
					headers,
					params,
				})
				.then((res) => {
					this.searchEndUserTimer = null
					this.endUsers = res.data.customer_companies
					this.errorEndUserFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeEndUser(customer_company) {
			// テキスト追加時の削除
			if (!this.endUsers.includes(this.client.endUser)) {
				this.errorEndUserFlag = true
				this.matter.endUser = null
				this.$refs.end_user_combobox.reset()
			}
			// エンドユーザー担当者をセット
			if (customer_company) {
				const customerCompany = this.customer_companies.find((v) => v.id == customer_company.id)
				this.customerPersons = customerCompany.customer_people
			}
		},
		changePlantCompany() {
			// テキスト追加時の削除
			if (!this.plantCompanies.includes(this.client.plantCompany)) {
				this.errorPlantCompanyFlag = true
				this.matter.plantCompany = null
				this.$refs.plant_company_combobox.reset()
			}
		},
		addForm() {
			this.count++
			const max = 9
			const additionalForm = {}
			if (this.count > max) return

			// 9個目のテキストフィールド出現時にアイコンを非表示
			if (this.count == max) {
				this.disabled = true
				setTimeout(() => {
					let elem = document.getElementById(`icon9`)
					elem.style.display = "none"
				}, 1)
			}
			this.distributionChannels.push(additionalForm)
		},
		setSearchDistributionChannel(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.distribution_channels = []
			this.distributionChannelKeyword = e.target.value
			clearTimeout(this.searchdistributionChannelTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.distributionChannelKeyword.length) return // 0文字の場合はreturn
			this.searchdistributionChannelTimer = setTimeout(this.searchDistributionChannel, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		changeDistributionChannel(e, index) {
			if (!this.distribution_channels.includes(e)) {
				this.errorDistributionChannelFlag = true
				this.distributionChannels.forEach((distributionChannel) => {
					if (distributionChannel.value == e) {
						distributionChannel.value = null
					}
				})
				this.$refs.distribution_combobox[index].reset()
			}
			this.changeLabel(index)
		},
		searchDistributionChannel() {
			const params = {
				q: {
					name_cont: this.distributionChannelKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_customer_companies", {
					headers,
					params,
				})
				.then((res) => {
					this.searchRegularCustomersTimer = null
					this.distribution_channels = res.data.customer_companies
					this.errorDistributionChannelFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeLabel(index) {
			let elem = document.getElementById(`distribution${index + 1}`)
			elem.previousElementSibling.textContent = `${index + 1}社目の企業`
		},
	},
	computed: {
		regularCustomerHint() {
			if (this.regularCustomers.length) {
				return "得意先を選択してください"
			} else if (this.searchRegularCustomersTimer) {
				return "得意先を取得しています"
			} else if (!this.regularCustomers.length && this.regularCustomerKeyword) {
				return "該当する得意先が存在していません"
			} else if (this.errorRegularCustomerFlag && !this.regularCustomerKeyword) {
				return "選択肢から得意先を選択してください"
			} else {
				return "会社名を入力してください"
			}
		},
		endUserHint() {
			if (this.endUsers.length) {
				return "エンドユーザーを選択してください"
			} else if (this.searchEndUserTimer) {
				return "エンドユーザーを取得しています"
			} else if (!this.endUsers.length && this.endUserKeyword) {
				return "該当するエンドユーザーが存在していません"
			} else if (this.errorEndUserFlag && !this.endUserKeyword) {
				return "選択肢からエンドユーザーを選択してください"
			} else {
				return "会社名を入力してください"
			}
		},
		plantCompanyHint() {
			if (this.plantCompanies.length) {
				return "プラントメーカーを選択してください"
			} else if (this.searchPlantCompanyTimer) {
				return "プラントメーカーを取得しています"
			} else if (!this.plantCompanies.length && this.plantCompanyKeyword) {
				return "該当するプラントメーカーが存在していません"
			} else if (this.errorPlantCompanyFlag && !this.plantCompanyKeyword) {
				return "選択肢からプラントメーカーを選択してください"
			} else {
				return "会社名を入力してください"
			}
		},
		setRegularCustomer: {
			get() {
				return this.client.regularCustomer
			},
			set(newValue) {
				return this.$emit("update:client", newValue)
			},
		},
		setEndUser: {
			get() {
				return this.client.endUser
			},
			set(newValue) {
				return this.$emit("update:client", newValue)
			},
		},
		setCustomerPerson: {
			get() {
				return this.client.customerPerson
			},
			set(newValue) {
				return this.$emit("update:client", newValue)
			},
		},
	},
	watch: {
		editRegularCustomerPersons: {
			immediate: true,
			handler() {
				if (this.editRegularCustomerPersons.length) {
				this.regularCustomerPersons = this.editRegularCustomerPersons
				}
			},
		},
		editCustomerPersons: {
			immediate: true,
			handler() {
				if (this.editCustomerPersons.length) {
				this.customerPersons = this.editCustomerPersons
				}
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.icon {
	position: relative;
	left: 4.5rem;
	top: 7px;
}
</style>
